import { api } from '../core';

interface UpdateChronologyEntrySummaryResponse {
  success: boolean;
}

interface UpdateChronologyEntrySummaryProps {
  abortController?: AbortController;
  entryId: string;
  summary: string;
}

const chronologyEntrySummaryUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntrySummary: builder.query<
      UpdateChronologyEntrySummaryResponse,
      UpdateChronologyEntrySummaryProps
    >({
      query: ({ abortController = new AbortController(), entryId, summary }: UpdateChronologyEntrySummaryProps) => ({
        url: 'chronology/entry/summary/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          summary
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntrySummary in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntrySummaryQuery } = chronologyEntrySummaryUpdateApi;
